const basePath = process.env.BASE_URL

export default {
  async retrieveStaticData (path) {
    const response = await fetch(`${basePath}${path}`)
    const data = await response.json()
    return data
  }
}